// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const AlertIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3.53 22A3 3 0 011 17.5L9.43 3.35a3 3 0 015.12 0L23 17.49a3.11 3.11 0 01.45 1.51 3 3 0 01-3 3zm7.62-17.62L2.68 18.51a1 1 0 00.37 1.36 1.05 1.05 0 00.49.13h16.93a1 1 0 00.69-.3 1 1 0 00.29-.71 1 1 0 00-.14-.49L12.85 4.37A1 1 0 0011.48 4a.9.9 0 00-.33.38z"/><path d="M12 14a1 1 0 01-1-1V9a1 1 0 012 0v4a1 1 0 01-1 1zm0 4a1 1 0 110-2 1 1 0 010 2z"/></svg>'} />;

AlertIcon.displayName = 'AlertIcon';

export default AlertIcon;
